

export const SevenGalaxiesTheme = {
  primary: "rgba(255, 255, 255)",
  background_color: "rgba(255, 255, 255, .3)",
  background_color_transp: "rgba(255, 255, 255, .05)",
  text_color: "white",
  box_shadow_insent: "rgba(255, 255, 255, .8)",
  border: "#fff",
  filter: "invert(0%) sepia(4%) saturate(27%) hue-rotate(75deg) brightness(105%) contrast(110%)",
  filterIcone: "invert(100%)",
  // background_image: "linear-gradient( rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(" + SevenG + ")"
  //https://isotropic.co/tool/hex-color-to-css-filter/
  //https://angel-rs.github.io/css-color-filter-generator/
}

export const GaiaTheme = {
  primary: "rgba(255, 132, 0)",
  background_color: "rgba(255, 132, 0, .8)",
  background_color_transp: "rgba(255, 132, 0, .1)",
  text_color: "white",
  box_shadow_insent: "rgba(255, 198, 0, .8)",
  border: "#ffc600",
  filter: "invert(30%) sepia(88%) saturate(3910%) hue-rotate(1deg) brightness(104%) contrast(104%)",
  filterIcone: "",
  // background_image: "linear-gradient( rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(" + Gaia + ")"
}

export const StrojTheme = {
  primary: "rgba(2, 194, 183)",
  background_color: "rgba(2, 194, 183, .8)",
  background_color_transp: "rgba(2, 194, 183, .1)",
  text_color: "white",
  box_shadow_insent: "rgba(0, 255, 210, .8)",
  border: "#00ffd2",
  filter: "invert(15%) sepia(57%) saturate(2659%) hue-rotate(139deg) brightness(110%) contrast(98%)",
  filterIcone: "",
  // background_image: "linear-gradient( rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(" + Stroj + ")"
}

export const AdroitTheme = {
  primary: "rgba(9, 158, 34)",
  background_color: "rgba(9, 158, 34, .8)",
  background_color_transp: "rgba(9, 158, 34, .1)",
  text_color: "white",
  box_shadow_insent: "rgba(0, 223, 39, .8)",
  border: "rgb(2, 228, 23)",
  filter: "brightness(0) saturate(100%) invert(45%) sepia(100%) saturate(4585%) hue-rotate(118deg) brightness(97%) contrast(93%)",
  filterIcone: "",
  // background_image: "linear-gradient( rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(" + Stroj + ")"
}

export const MajikTheme = {
  primary: "rgba(110, 0, 213)",
  background_color: "rgba(110, 0, 213, .8)",
  background_color_transp: "rgba(110, 0, 213, .1)",
  text_color: "white",
  box_shadow_insent: "rgba(166, 70, 253, .8)",
  border: "rgb(178, 67, 255)",
  filter: "brightness(0) saturate(100%) invert(17%) sepia(98%) saturate(3832%) hue-rotate(269deg) brightness(76%) contrast(132%)",
  filterIcone: "",
  // background_image: "linear-gradient( rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(" + Stroj + ")"
}
